import axios from 'axios';

export const gracenoteApiCall = async ({
  params = {},
  url = '',
  method = 'GET',
}) => {
  return await axios({
    url: `https://gracenoteclaro.akamaized.net/gsd/lookup/v1${url}`,
    // url: `https://api.sports.gracenote.com/gsd/lookup/v1${url}`,
    params: {
      language: 'es-ES',
      api_key: 'y368pewmkbqewyaha8xydgc5',
      ...params
    },
    method,
  });
};
